import { Logger } from '@utils/logger/logger';
import WeddingAPIClient from '@xo-union/sdk-weddings';

import weddingsRootUrl from '@api/helpers/weddingsRootUrl';
import { WEDDING_DATE_GRANULARITY } from './constants';

/** @internal */
export const FETCH_WEDDING = 'FETCH_WEDDING';
/** @internal */
export const FETCH_WEDDING_SUCCESS = 'FETCH_WEDDING_SUCCESS';
/** @internal */
export const FETCH_WEDDING_FAILURE = 'FETCH_WEDDING_FAILURE';
/** @internal */
export const WEDDING_DATE_CONFIRMED = 'WEDDING_DATE_CONFIRMED';

function createClient(token) {
	return new WeddingAPIClient({
		host: weddingsRootUrl(),
		apiKey: process.env.WEDDINGS_API_KEY,
		membershipSessionToken: token,
	});
}

/** @internal */
/** @type {{ weddingMarket: object, error: unknown, isFetching: boolean, weddingDateGranularity?: import('./constants').WeddingDateGranularity }} */
export const initialState = {
	weddingMarket: {},
	error: null,
	isFetching: false,
	weddingDateGranularity: undefined,
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_WEDDING:
			return {
				...state,
				isFetching: true,
			};
		case FETCH_WEDDING_SUCCESS:
			return {
				...state,
				id: action.response.wedding.id,
				isFetching: false,
				weddingMarket: action.response.wedding.market,
				weddingDateGranularity:
					action.response.wedding.wedding_date_granularity,
			};
		case FETCH_WEDDING_FAILURE:
			return {
				...state,
				isFetching: false,
				error: action.error,
			};
		case WEDDING_DATE_CONFIRMED:
			return {
				...state,
				weddingDateGranularity: WEDDING_DATE_GRANULARITY.EXACT,
			};
		default:
			return state;
	}
}

export const confirmWeddingDate = () => ({ type: WEDDING_DATE_CONFIRMED });

export function fetchWedding(memberId, token) {
	const weddingClient = createClient(token);
	return (dispatch) => {
		dispatch({ type: FETCH_WEDDING });
		return weddingClient.getWeddingByMemberId(memberId).then(
			({ body }) => {
				dispatch({ type: FETCH_WEDDING_SUCCESS, response: body });
			},
			(error) => {
				dispatch({ type: FETCH_WEDDING_FAILURE, error });
				Logger.error({
					log_messahge: 'Error fetching wedding',
					errorToLog: error,
					newRelic: true,
				});
			},
		);
	};
}

export const getWeddingCity = (state) =>
	state.wedding &&
	state.wedding.weddingMarket &&
	state.wedding.weddingMarket.city;
export const getWeddingState = (state) =>
	state.wedding &&
	state.wedding.weddingMarket &&
	state.wedding.weddingMarket.state;
